import React, { FC } from 'react';
import { UserRoleE } from '../../models/enums';
import { useAppSelector } from '../../store/hooks';
import { selectCurrentUser } from '../../store/selectors/authSelectors';

type AccessRightsPropTypes = {
    accessFor?: UserRoleE | UserRoleE[];
    condition?: boolean;
    children: any;
}

// The gate is DERIVED during render, never latched into state. It used to be a useState + useEffect
// pair whose array branch only ever called setPass(true) on a match (no else) and whose deps were
// [accessFor] alone, so it could open but never close: once a matching role had been seen, the
// children stayed rendered for every later role. That leaked "+ New campaign" to a MediaCompany user
// who had switched accounts through an AdvertisingAgency one - both roles land on /campaigns, and
// NavRoutes keys routes by `path`, so the page (and this gate) never unmounts across the switch.
// A primitive `accessFor` was worse: referentially stable, so the effect never re-ran at all and a
// role change was ignored until a remount. Keep this a plain computation - it re-evaluates on every
// role/condition change by construction, and renders correctly on the first paint (no flash).
//@ts-ignore
const AccessRights: FC<AccessRightsPropTypes> = ({ accessFor, children, condition = true }) => {
    const currentUser = useAppSelector(selectCurrentUser);

    if (!currentUser) return null;

    const roleMatches = !accessFor
        ? true
        : Array.isArray(accessFor)
            ? accessFor.some(role => role === currentUser.role)
            : accessFor === currentUser.role;

    return (roleMatches && condition) ? children : null;
};

export default AccessRights;
